import API from "./axios"

// get profile
export const getProfile = () => API.get("/profile")

// update profile
export const updateProfile = (data) => API.put("/profile", data)

// upload profile image
export const uploadProfileImage = (file) => {
  const formData = new FormData()
  formData.append("profile_image", file)

  return API.post("/upload-profile-image", formData, {
    headers: { "Content-Type": "multipart/form-data" }
  })
}

// admin list users
export const listUsers = () => API.get("/list-users")

// delete user
export const deleteUser = () => API.delete("/delete-user")